import React, { useEffect, useState } from "react";

function idsCotaProp(idCota) {
  return Array.isArray(idCota) ? idCota : [idCota];
}

/** Cotas operacionais de SLA por plano: Lite M = 4, Lite = 7, Advance = 15. */
function cotaSlaPatrocinador(idPlano, cotaSecao) {
  const id = Number(idPlano);
  if (id === 6) return 4; // Lite M
  if (id === 4) return 7; // Lite
  if (id === 3) return 15; // Advance
  if (cotaSecao === "LITE") return 7;
  if (cotaSecao === "ADVANCE") return 15;
  return 30;
}

function AreaPatrocinadoresAdm(props) {
  const [patrocinadores, setPatrocinadores] = useState([]);

  useEffect(() => {
    const idsCota = idsCotaProp(props.id_cota);
    const arrayPatrocinadores = (props?.patrocinadores || []).filter((p) => {
      return idsCota.includes(p.id_plano);
    });
    setPatrocinadores(arrayPatrocinadores);
  }, [props.patrocinadores, props.id_cota]);

  if (!patrocinadores?.length) return null;

  return (
    <section className="amd-cota" aria-label={`Cota ${props.cota}`}>
      <div className="amd-cota-header">
        <h2 className="amd-cota-title">{props.cota}</h2>
        <span className="apl-tag-plan">
          {patrocinadores.length}{" "}
          {patrocinadores.length === 1 ? "patrocinador" : "patrocinadores"}
        </span>
      </div>

      <div className="amd-cota-grid">
        {patrocinadores.map((p) => {
          const metaSla = cotaSlaPatrocinador(p.id_plano, props.cota);
          const sla =
            p.entregues !== 0
              ? Math.round((p.entregues / metaSla) * 100)
              : 0;
          return (
            <article key={p.id} className="apl-card amd-sponsor-card">
              <div className="amd-sponsor-card__head">
                <h3 className="amd-sponsor-card__name">{p.patrocinador}</h3>
                {p.id_plano === 6 ? (
                  <span className="apl-tag-type">Lite M</span>
                ) : null}
              </div>
              <div className="apl-table-wrap">
                <table className="apl-table amd-sponsor-table">
                  <tbody>
                    <tr>
                      <td>Reuniões agendadas</td>
                      <td className="amd-num">
                        {p.agenda_patrocinador?.length ?? 0}
                      </td>
                    </tr>
                    <tr>
                      <td>Reuniões futuras</td>
                      <td className="amd-num">{p.futuras}</td>
                    </tr>
                    <tr>
                      <td>Reuniões realizadas</td>
                      <td className="amd-num">{p.entregues}</td>
                    </tr>
                    <tr>
                      <td>No shows</td>
                      <td className="amd-num">{p.noshow}</td>
                    </tr>
                    <tr>
                      <td>
                        <span className="amd-sla-label">SLA</span>
                        <span className="amd-sla-calc" title="Cota / realizadas usadas no cálculo do SLA">
                          {metaSla} (cota) / {Number(p.entregues ?? 0)}{" "}
                          (realizadas)
                        </span>
                      </td>
                      <td className="amd-num amd-num--sla">{sla} %</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default AreaPatrocinadoresAdm;
